<template>
  <div class="en_wrapper">
        <div class="page page1">
          <div class="en_header">
            <h1>創鉅有限合夥交易申請書</h1>
            <div class="nb">
              合約編號：<div class="con-nb"><span></span></div>
            </div>
          </div><!--header-->
          <div class="top">
            <div class="top-car">
              車種：
              <div class="con0">
                    <span class="checkbox"><input type="checkbox" checked disabled></span>機車&nbsp;<span class="checkbox"><input type="checkbox" disabled></span>電動車&nbsp;<span class="checkbox"><input type="checkbox" disabled></span>重機
                  </div>
            </div><!--top-car-->
            <div class="top-name">
              專案名稱：<span>中租輪你貸-經銷商方案</span>
            </div>
            <div class="top-nb">
              經銷商統編：<div class="con-top-nb"><span></span></div>
            </div>
            <div class="top-date">
              申請日期：<div class="con-top-date"><span>{{editedItem.applyDate.year}}/{{editedItem.applyDate.month}}/{{10}}</span></div>
            </div>
          </div><!--top-->
          <div class="area1">
            <div class="en_title">申請資訊</div>
            <table class="table1">
              <tr>
                <td width="245px">
                  <span class="tdTit">申請金額：</span>
                  <div class="con1"><span>{{editedItem.vendor.totalCreditPrice}}</span></div>
                </td>
                <td width="220px">
                  <span class="tdTit">期數：</span>
                  <div class="con2">{{editedItem.vendor.installmentsNumber}}</div>
                  </td>
                <td class="tdEnd">
                  <span class="tdTit">期付款：</span>
                  <div class="con3">{{editedItem.vendor.creditPriceMonth}}</div>
                </td>
              </tr>
            </table>
            <table class="table2">
              <tr class="tr">
                <td colspan="4" class="tdEnd">
                  <span class="tdTit">帳單地址:</span>
                  <div class="con4">
                    <span class="checkbox"><input type="checkbox" checked disabled></span>通訊地<span class="checkbox"><input type="checkbox" disabled></span>現居地<span class="checkbox"><input type="checkbox" disabled></span>戶籍&nbsp;<span class="checkbox"><input type="checkbox" disabled></span>其他&nbsp;
                    <div class="con4-1">{{editedItem.customer.home.residenceAddress}}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td width="55px"><span class="tdTit">行照資料</span></td>
                <td width="135px" class="tdEnd">
                  <span class="tdTit">車號：</span>
                  <div class="con5"></div>
                </td>
                <td width="190px" class="tdEnd">
                  <span class="tdTit">排氣量cc/馬力：</span>
                  <div class="con6"></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">廠牌型式：&nbsp;出廠年月：</span>
                  <div class="con7"></div>
                  <div class="con7-2"></div>
                </td>
              </tr>
            </table>
          </div><!--area1-->
          <div class="area2">
            <div class="en_title">申&nbsp;&nbsp;請&nbsp;&nbsp;人</div>
            <div class="en_title2">個人資料</div>
            <table class="table3">
              <tr>
                <td width="120px">
                  <span class="tdTit">姓名：</span>
                  <div class="con8"><span>{{editedItem.customer.name}}</span></div>
                </td>
                <td width="158px">
                  <span class="tdTit">身分證字號：</span>
                  <div class="con9">{{editedItem.customer.memberId}}</div>
                  </td>
                <td width="178px">
                  <span class="tdTit">身分證換證日期：</span>
                  <div class="con10"></div>
                </td>
                <td width="92px">
                  <div class="con11">
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.married[0].value === true"></span>已婚
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.married[1].value === true"></span>未婚
                    <span class="checkbox"><input type="checkbox" disabled></span>其他
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">生日：</span>
                  <div class="con12"><div class="y">{{editedItem.customer.birthdayInfo.year}}</div>/<div class="m">{{editedItem.customer.birthdayInfo.month}}</div>/<div class="d">{{editedItem.customer.birthdayInfo.day}}</div></div>
                </td>
              </tr>
            </table><!--table3-->
            <table class="table4">
              <tr>
                <td width="153px" class="tdEnd">
                  <span class="tdTit">戶籍地址：</span>
                  <div class="con13">
                    <span class="checkbox"><input type="checkbox" disabled></span>同身分證住址&nbsp;&nbsp;&nbsp;&nbsp;<span class="checkbox"><input type="checkbox" disabled></span>其他
                  </div>                 
                </td>
                <td width="395px">
                  <span class="tdTit">電話：</span>
                   <div class="con14">
                    <div class="con14-1">{{editedItem.customer.phone}}</div>
                    <div class="con14-2">{{editedItem.customer.home.residenceAddress}}</div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">行動電話：</span>
                  <div class="con15">{{editedItem.customer.cellphone}}</div>    
                </td>
              </tr>
            </table><!--table4-->
            <table class="table5">
              <tr>
                <td width="108px" class="tdEnd">
                  <span class="tdTit">通訊地址：</span>
                  <div class="con16">
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.home.homeType1[0].value"></span>戶籍
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.home.homeType1[1].value"></span>其他
                  </div>                 
                </td>
                <td width="440px">
                  <span class="tdTit">電話：</span>
                    <div class="con17">
                      <div class="con17-1">{{editedItem.customer.homePhone}}</div>
                      <div class="con17-2">{{editedItem.customer.home.homeAddress1}}</div>
                    </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">E-mail：</span>
                  <div class="con18">{{editedItem.customer.email}}</div>    
                </td>
              </tr>
            </table><!--table5-->
            <table class="table6">
              <tr>
                <td width="359px">
                  <span class="tdTit tdTit19">現居地住</span>
                  <div class="con19">{{editedItem.customer.home.liveYear}}</div><span class="tdTit tdTit19-2">年</span>  
                  <div class="con20">
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.home.liveLevel[0].value"></span>自有\配偶\親人所有
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.home.liveLevel[3].value"></span>租屋
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.customer.home.liveLevel[5].value"></span>其他/朋友/其他親戚/無法判斷
                  </div>
                  <div class="con21"><div class="con21-1"></div></div>      
                </td>
                <td width="189px">
                  <div class="con22">
                    <span class="checkbox"><input type="checkbox" disabled></span>是否有信用卡/銀行名稱
                  </div>
                  <div class="con23">{{editedItem.bank.name}}</div>                 
                </td>
                <td class="tdEnd">
                  <span class="tdTit">學歷：</span>
                  <div class="con24"></div>
                </td>
              </tr>
            </table><!--table6-->
            <table class="table7">
              <tr>
                <td width="264px">
                  <span class="tdTit">聯絡人姓名：</span>
                  <div class="con25">{{editedItem.firstContact.name}}</div>
                </td>
                <td width="189px">
                  <span class="tdTit">聯絡人關係：</span>
                  <div class="con26">{{editedItem.firstContact.type}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">聯絡人電話：</span>
                  <div class="con27">{{editedItem.firstContact.cellphone}}</div>
                </td>
              </tr>
            </table><!--table7-->
            <div class="en_title3">就業資料</div>
            <table class="table8">
              <tr class="tr">
                <td width="48px" rowspan="2" style="border-bottom:0">
                  <div class="con28">
                    <span class="checkbox"><input type="checkbox" disabled></span>就業中
                  </div>
                </td>
                <td width="216px">
                  <span class="tdTit">公司名稱：</span>
                  <div class="con29">{{editedItem.company.name}}</div>
                </td>
                <td width="214px">
                  <span class="tdTit">職稱：</span>
                  <div class="con30">{{editedItem.company.title}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit31">公司電話：</span>
                  <div class="con31">(<div class="con31-1"></div>)&nbsp;<div class="con31-2">{{editedItem.company.phone}}</div></div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="tdTit tdTit32">年資</span>
                  <div class="con32">{{editedItem.company.workYear}}</div>
                  <span class="tdTit tdTit32-2">年</span>
                </td>
                <td class="tdEnd" colspan="2">
                  <span class="tdTit">月收入：</span>
                  <div class="con33">{{editedItem.company.salary}}</div>
                </td>
              </tr>
            </table><!--table8-->
            <table class="table9">
              <tr class="tr">
                <td width="48px">
                  <div class="con34">
                    <span class="checkbox"><input type="checkbox" disabled></span>家管
                  </div>
                </td>
                <td width="150px">
                  <span class="tdTit">配偶姓名：</span>
                  <div class="con35">{{editedItem.firstContact.name}}</div>
                </td>
                <td width="161px">
                  <span class="tdTit">配偶手機：</span>
                  <div class="con36">{{editedItem.firstContact.cellphone}}</div>
                </td>
                <td width="151px">
                  <span class="tdTit tdTit37">配偶公司名稱：</span>
                  <div class="con37"></div>
                </td>
                <td  class="tdEnd">
                  <span class="tdTit tdTit38">配偶公司電話：</span>
                  <div class="con38">(<div class="con38-1"></div>)&nbsp;<div class="con38-2">{{editedItem.firstContact.companyPhone}}</div></div>
                </td>
              </tr>
              <tr class="tr">
                <td>
                  <div class="con39">
                    <span class="checkbox"><input type="checkbox"></span>學生
                  </div>
                </td>
                <td colspan="2">
                  <span class="tdTit">學校名稱：</span>
                  <div class="con40"></div>
                </td>
                <td colspan="2"  class="tdEnd">
                  <span class="tdTit">科系：</span>
                  <div class="con41"></div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="con42">
                    <span class="checkbox"><input type="checkbox"></span>待業中
                  </div>
                </td>
                <td colspan="4" class="tdEnd">
                  <div class="con43"></div>
                </td>
              </tr>
            </table><!--table9-->
          </div><!--area2-->
          <div class="area3">
            <div class="en_title">連帶保證人</div>
            <table class="table10">
              <tr>
                <td width="148px">
                  <span class="tdTit">姓名：</span>
                  <div class="con44">{{editedItem.jointGuarantor.name}}</div>
                </td>
                <td width="179px">
                  <span class="tdTit">身分證字號：</span>
                  <div class="con45">{{editedItem.jointGuarantor.memberId}}</div>
                </td>
                <td width="104px">
                  <div class="con46">
                    <span class="checkbox"><input type="checkbox" disabled></span>已婚<span class="checkbox"><input type="checkbox" disabled></span>未婚<span class="checkbox"><input type="checkbox" disabled></span>其他
                  </div>
                </td>
                <td width="208px">
                  <span class="tdTit">生日：</span>
                  <div class="con47">
                    <div class="y">{{editedItem.jointGuarantor.birthdayInfo.year}}</div>/<div class="m">{{editedItem.jointGuarantor.birthdayInfo.month}}</div>/<div class="d">{{editedItem.jointGuarantor.birthdayInfo.day}}</div>
                  </div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">關係：</span>
                  <div class="con48">{{editedItem.jointGuarantor.type}}</div>
                </td>
              </tr>
            </table><!--table10-->
            <table class="table11">
              <tr class="tr">
                <td width="431px">
                  <span class="tdTit">戶籍地址：</span>
                  <div class="con49">
                    <span class="checkbox"><input type="checkbox"></span>同身分證住址&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="checkbox"><input type="checkbox"></span>其他&nbsp;
                    <div class="con49-1">{{editedItem.jointGuarantor.home.residenceAddress}}</div>
                  </div>
                </td>
                <td width="133px">
                  <span class="tdTit">電話：</span>
                  <div class="con50">{{editedItem.jointGuarantor.homePhone}}</div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit">行動電話：</span>
                  <div class="con51">{{editedItem.jointGuarantor.cellphone}}</div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="tdTit">通訊地址：</span>
                  <div class="con52">
                    <span class="checkbox"><input type="checkbox"></span>戶籍&nbsp;&nbsp;<span class="checkbox"><input type="checkbox"></span>公司地&nbsp;&nbsp;&nbsp;<span class="checkbox"><input type="checkbox"></span>其他
                    
                  </div>
                  <span class="tdTit tdTit53 ">電話：</span>
                  <div class="con53">
                    <div class="con53-1"></div>
                    <div class="con53-2">{{editedItem.jointGuarantor.home.homeAddress2}}</div>
                  </div>
                </td>
                <td class="tdEnd"></td>
              </tr>
            </table><!--table11-->
            <table class="table12">
              <td width="327px">
                <span class="tdTit tdTit54">現居地住</span>
                <div class="con54">{{editedItem.jointGuarantor.home.liveYear}}</div>
                <span class="tdTit tdTit54-2">年</span>
                <div class="con55">
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[0].value"></span>自有\配偶所有
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[2].value"></span>父母\子女所有
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[3].value"></span>租賃
                    <span class="checkbox"><input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel[5].value"></span>其他
                    <div class="con55-1"></div>
                </div>
              </td>
              <td width="237px">
                <span class="tdTit tdTit56">學歷</span>
                <div class="con56">
                    <span class="checkbox"><input type="checkbox" disabled></span>研究所&nbsp;<span class="checkbox" disabled><input type="checkbox"></span>大學/大專&nbsp;<span class="checkbox"><input type="checkbox" disabled></span>高中職&nbsp;<span class="checkbox" disabled><input type="checkbox"></span>初中及以下
                </div>
              </td>
              <td width="94px">
                <span class="tdTit tdTit57">月收入</span>
                <div class="con57"></div>
              </td>
              <td class="tdEnd">
                <span class="tdTit tdTit58">年資</span>
                <div class="con58">{{editedItem.company.workYear}}</div>
                <span class="tdTit tdTit58-2">年</span>
              </td>
            </table><!--table12-->
            <table class="table13">
              <tr>
                <td width="148px">
                  <span class="tdTit">任職公司：</span>
                  <div class="con59"><div class="con59-1">{{editedItem.jointGuarantor.companyName}}</div></div>
                </td>
                <td width="103px">
                  <span class="tdTit">職稱：</span>
                  <div class="con60"><div class="con60-1">{{editedItem.jointGuarantor.title}}</div></div>
                </td>
                <td class="tdEnd">
                  <span class="tdTit tdTit61">公司地址：電話：</span>
                  <div class="con61">
                    <div class="con61-1"></div>
                    <div class="con61-2">{{editedItem.jointGuarantor.companyPhone}}</div>
                  </div>
                </td>
              </tr>
            </table><!--table13-->
          </div><!--area3-->
          <div class="area4">
            <div class="en_title"><span>分期付款約定暨個人資料保護條款【創鉅有限合夥保留申請核准與否的權利】</span></div>
            <div class="listBox">
              <p class="p1"><b>對於創鉅有限合夥機車分期專案(以下簡稱「本案」)之申請，申請人及連帶保證人(如有)確認並同意以下約定條款(以下簡稱「本條款」):</b></p>
              <ul class="list">
                <li><b><u>本案為中租旗下之「創鉅有限合夥」(以下簡稱「創鉅」)提供，申請人及申請人之連帶保證人(以下統稱「申請人等」)知悉並同意創鉅保留本案申請核准與否及最終交易金額、利率、期間等各項條件之決定權利，創鉅對於本案各項債權文件未簽署用印確認前，對創鉅並無拘束力，創鉅仍保有對本案各項債權文件及撥款與否之最終決定權。申請人並同意不可撤銷地授權創鉅依核准條件於相關債權文件中填載本案相關資訊(包括但不限於利率等)。</u></b></li>
                <li><b><u>申請人等知悉仲信資融股份有限公司之「零卡分期」之可使用額度會扣減本案核准金額，並同意如下:<br/>
              (1)創鉅得將本案之核准、撥款及還款等資訊(包括但不限於核准與否、金額、撥款日期及還款情況等)提供予本平台及仲信資融股份有限公司(以下簡稱「仲信資融」)。<br/>
              (2)倘申請人為仲信資融「零卡分期」之申請者或會員，申請人了解並同意仲信資融得將「零卡分期」申請核准與否及會員額度等相關資訊提供予創鉅作為本案審核等作業之參考。<br/>
              (3)申請人同意於本案核准時，仲信資融「零卡分期」之可使用額度會立即扣减本案核准之金額。</u></b></li>
                <li><b>本案經核准後，申請人委託創鉅將創鉅撥付予申請人之本案買賣價金扣除動產擔保設定費用、手續費後，將餘款撥付申請人提供之指定帳戶（依申請人提供之本人之存摺影本）。於創鉅將該扣除後之款項全數撥付至該指定帳戶後，即視為創鉅已依前述買賣契約之約定將買賣價金給予申請人無誤。</b></li>
                <li>本案可由創鉅委託之公司或人員處理有關本案之申請等作業，惟未透過其他代辦公司辦理。除本條款及本案分期付款買賣契約所載費用外，無其他人員向申請人等收取額外費用或報酬。</li>
                <li>申請人申請及辦理本案而提供本人及連帶保證人等之個人資料、檔案、申請文件與後續簽署用印之所有債權文件，如因故無法通過創鉅之審核或已核准後，申請人未與創鉅往來者，申請人等同意創鉅無須返還相關文件及檔案。</li>
                <li><b>申請人等聲明並保証對於本條款為申請人等之本人親自同意，如有連帶保證人，亦經該連帶保證人本人親自同意，對於本案之所有債權文件(包含但不限於分期付款買賣契約、本票)亦均為申請人等之<u>本人親自簽署用印</u>，如有違反或就同意、簽署用印之效力有所爭議，申請人等仍應自負其責，並賠償創鉅因此所受之損害。</b></li>
                <li><b>申請人等應共同擔任發票人簽發本票乙紙交付創鉅收執。申請人如有違反本案分期付款買賣契約時，申請人等不可撤銷地授權創鉅及其指定之人填載本票到期日及其他依票據法規定行使票據權利所應記載之事項，且創鉅得使用此本票作為其違約時依本案分期付款買賣契約應負一切債務求償之用。</b></li>
                <li>申請人等知悉並同意本案所申請之買賣交易關係為申請人賣出本案標的予創鉅，申請人再以分期付款買賣契約承買本案標的。</li>
                <li>分期價金款項之每月繳款日依創鉅規定之週期；申請人須自行負擔分期價金繳款手續費，實際金額及繳款日以創鉅提供之繳款通知書所載為準；縱申請人未接獲繳款通知書，申請人仍應依本案分期付款買賣契約(附表)記載之付款日期，前往全國各地銀行、郵局或金融機構以匯款方式將應付款項匯入創鉅指定帳戶內。</li>
                <li><u>申請人如有遲延給付分期價款、違反本條款或本案相關契約、擅自處分本案標的、退票、信用貶落、銀行拒往、受假執行、假扣押、假處分、終局執行、破產聲請、宣告、聲請債務協商、聲請更生或清算、死亡、失蹤、發生繼承而其繼承人聲明拋棄繼承、本案連帶保證人拒絕履行保證責任或其保證能力明顯不足、本案標的遭扣押或其他足以影響創鉅權益等情事之一發生時，所有未到期分期價款視為提前全部到期，創鉅得不經催告或通知，逕行要求申請人等立即清償全部債務，申請人等並應另支付自遲延繳款日或違約日起至清償日止，依年利率百分之二十約定利率計收之遲延利息。</u></li>
                <li>申請人如有遲延給付分期價金，除創鉅得依約向申請人及其連帶保證人請求該分期價金及收取按年息20%計算之遲延利息外，得另行收取<b>新台幣100 元</b>之法務催繳作業管理費用並逐期計算。<b>(本條款第12~21條列於背面)</b></li>
              </ul>
              <p class="p2"><b><u>申請人等之本人均已於合理期間內對本分期付款約定暨個人資料保護條款審閱無誤，且充分了解同意。</u></b></p>
              <p class="p3">此致&nbsp;&nbsp;&nbsp;創鉅有限合夥</p>
              <p class="p4">申請人(包括申請人及連帶保證人)簽章</p>
              <div class="grayBox"></div>
            </div><!--listBox-->
          </div><!--area4-->
          <div class="ft">109&nbsp;年&nbsp;3&nbsp;月版(經銷商/機車)</div>
            

        </div><!--page1-->
        <div class="page page2">
          <h4>中&nbsp;&nbsp;古&nbsp;&nbsp;機&nbsp;&nbsp;車&nbsp;&nbsp;分&nbsp;&nbsp;期&nbsp;&nbsp;付&nbsp;&nbsp;款&nbsp;&nbsp;買&nbsp;&nbsp;賣&nbsp;&nbsp;契&nbsp;&nbsp;約</h4>
          <table class="table1">
            <tr>
              <td width="445px">
                <span class="tdTit">甲方(即出賣人)：&nbsp;&nbsp;創鉅有限合夥乙方&nbsp;(&nbsp;即買受人&nbsp;)：</span>
                <div class="con1">{{editedItem.customer.name}}</div>

              </td>
              <td width="190px">
                <span class="tdTit">標的物車號：</span>
                <div class="con2"></div>
              </td>
              <td>
                <span class="tdTit">廠牌：</span>
                <div class="con3"></div>
              </td>
            </tr>
            <tr>
              <td>
                <span class="tdTit">價金給付方式：&nbsp;總價：新台幣</span>
                <div class="con4">給付方式</div>
                <div class="con5">{{editedItem.vendor.totalCreditPrice}}</div>
                <span class="tdTit5">元整（含稅）</span>
              </td>
              <td>
                <span class="tdTit">排氣量：</span>
                <div class="con6"></div>
              </td>
              <td>
                <span class="tdTit">出廠年月：</span>
                <div class="con7"></div>
              </td>
            </tr>
          </table><!--table1-->
          <p class="p1">
            ⦿指乙方應給付之全部價金，除乙方違約外，甲方不再以其他名義，要求乙方給付額外金額。請依下列方式分期支付之：<br/>
            分期付款之起始月份自甲方撥付甲方先前買受本案標的物價款予乙方之次月起，每月為一期，共分<span class="p1-1">{{editedItem.vendor.installmentsNumber}}</span>期，每期新台幣<span class="p1-2">{{editedItem.vendor.creditPriceMonth}}</span>元整(含稅)，繳款日依甲方提供之繳款通知所載。
          </p><!--p1-->
          <p class="p2">
            交付方式／保固責任：<b><u>因乙方現已直接占有標的物車輛，雙方約定以民法第七百六十一條所規定之簡易交付方式，於本契約生效時已為讓與合意以完成交付。甲方及乙方同意依現況交車，甲方不負瑕疵擔保責任。</u></b><br/>
            其他約定事項：
          </p><!--p2-->
          <ul class="list">
            <li>個別商議條款：<br/>
              <ul class="listCon">
                <li><u><b>本案分期付款利率:<span class="list-1">10</span>%(含稅)</b>。乙方同意本契約分期款之營業稅應依甲方指定之方式及數額，自乙方繳付之分期款中優先扣抵。<b>乙方提前清償者，應按本契約之未償還價款總額給付</b></u>。</li>
                <li>乙方及其連帶保證人應共同擔任發票人簽發本票乙紙交付甲方收執。乙方如有違約時，甲方得使用此本票作為其違約時依本契約應負一切債務求償之用。乙方及其連帶保證人認知並同意，於乙方違反本契約任一項規定時，授權甲方及其指定之人填載到期日及其他依票據法規定行使票據權利所應記載之事項。此本票為分期付款買賣之分期價金款總額憑證，俟分期付款價金完全清償完畢時，此本票自動失效。</li>
                <li><b><u>如有分期價款發生遲延繳款之情況，除乙方及連帶保證人同意甲方依約向乙方及連帶保證人請求該分期價款及收取按年息20%計算之遲延利息外，得另行收取新台幣100元之法務催繳作業管理費用並逐期計算。</u></b></li>
                <li>於本契約債務全數清償後，甲方得交付相關清償文件予乙方或乙方之連帶保證人(如為連帶保證人清償者)或債務人委託之第三人。債務人或債務人之連帶保證人或債務人委託之第三人<u>欲申請補發者，每次申請須給付受讓人新台幣1000元之作業處理費用</u>。</li>
                <li><b><u>乙方及其連帶保證人已充分知悉且了解本契約之各條約款並同意受拘束，並親自簽署本契約及相關之債權文件，並同意不可撤銷地授權甲方依核准條件於相關債權文件中填載本案利率等分期資訊，連帶保證人承諾保證之效力不因與乙方簽約順序而受影響；就甲方收訖前述文件並按中古機車買賣契約之約定支付價金前，本契約對甲方並無拘束力，甲方仍保有本契約最終往來決定權；甲方支付價金後，則視為甲方已同意本契約之各條約款並同意受拘束，如甲方拒絕按中古機車買賣契約之約定支付價金，乙方同意甲方無須返還乙方簽署之文件原本及所提供之相關資料。</u></b></li>
                <li>如為擔保分期價金給付履行，經甲方要求，乙方應於簽署本契約之同時簽署車輛動產抵押契約書，並同意支付甲方<u>新台幣4500元作為本案標的動產抵押設定費用，且不可撤銷地授權甲方得自撥付予乙方之買賣款項中扣除，後續如因故解除或終止本案相關契約亦不予退還</u>；此外，甲方並得洽乙方或乙方同意之人提供其他擔保品。乙方須於全數清償對甲方所有往來契約之債務後，方得請求塗銷全數設定登記。</li>
              </ul><!--listCon-->
            <li>乙方及其連帶保證人同意甲方得於其營業登記項目或章程所訂之業務需要等特定目的範圍內，蒐集、處理及利用乙方及其連帶保證人之資料(包括但不限於與甲方及其轄下子公司或母公司往來業務查詢等內容），並得代理乙方及其連帶保證人收受前開向第三人查詢之相關資料。</li>
            <li>乙方及其連帶保證人均同意，甲方得將其依本契約所得主張之各項權利（包括對乙方及其連帶保證人之利息請求權、帳款返還請求權及甲方依本契約取得之抵押權等）再轉讓予第三人，如因債權讓與致須辦理各項變更手續時，乙方及其連帶保證人於接獲甲方通知後將立即配合辦理，否則願拋棄期限利益，甲方得請求提前清償全部債務，或縮短還款期限。</li>
            <li><b><u>乙方及乙方連帶保證人聲明無論本契約簽署前或後之車輛產權均無瑕疵及確係乙方完全合法所有，無動產擔保交易法施行細則第七條所列各款情形，他人並無法主張任何權利或設定負擔(包括但不限於本契約簽署前或後車輛並無遭當鋪或第三人占有)，亦無政府法令禁止扣押或禁止持有、轉讓或質押之物品；如有任何糾紛概由乙方及乙方連帶保證人自行負責處理，與甲方無關，如乙方及乙方連帶保證人聲明不實，甲方得對乙方及乙方連帶保證人主張應負民、刑事責任。</u></b></li>
            <li>每月繳款日依甲方規定之週期；<u><b>乙方須自行負擔分期價金繳款手續費</b>，實際金額及繳款日以甲方提供之繳款通知書所載為準</u>；縱乙方未接獲繳款通知書，乙方仍應依創鉅通知之每月繳款日，前往全國各地銀行、郵局或金融機構以匯款方式將應付款項匯入甲方指定帳戶內。</li>
            <li>乙方委由第三人代為清償時，不得要求甲方將車籍資料及清償證明等註銷動產抵押權文件交由第三人領取，乙方茲指示甲方將此等文件掛號郵寄交乙方收執。但由乙方連帶保證人代為清償者，乙方同意甲方得將此等文件逕交乙方連帶保證人並發給清償證明。</li>
            <li><u>乙方如有下列各款情事之一者，即喪失其分期償還之利益，甲方得不經通知逕行要求立即清償全部債務，乙方並同意甲方得對到期未付之各期分期價款按年息20%逐日計收遲延利息：1.乙方未依本契約約定清償債務，或償付費用、稅捐。2.乙方不履行或怠於履行其於本契約之任一義務、或未經甲方書面同意擅自處分本案標的物。3.乙方交付之票據未到期前，發票人被列為拒絕往來戶或發生退票情事，或因重大信用貶落而顯有到期不履行之虞。4.乙方因其他債務關係而受假扣押、假處分、假執行、終局執行等強制執行或受破產之聲請，或聲請和解、調解、或依消費者債務清理條例請求協商、聲請更生或清算、或本案標的物因違法情事遭扣押時。5.乙方或乙方連帶保證人死亡、失蹤或發生繼承而其繼承人聲明拋棄繼承時。6.乙方連帶保證人拒絕履行保證責任，或其保證能力顯為不足。7.其他事由足以影響甲方之權益。</u></li>
            <li><u>如乙方發生任何違約情事，乙方連帶保證人應立即清償乙方須給付甲方之一切債務及所有費用。</u>乙方連帶保證人同意甲方得不經其同意或事先通知，展延任一債務之清償期，乙方連帶保證人仍願繼續負連帶保證責任。乙方連帶保證人所負之責任至乙方對甲方因本契約所生之一切債務全部履行完畢之日為止。非經甲方書面同意，乙方連帶保證人不得終止本保證，縱使登報或以存證信函聲明退保亦一概不生效。</li>
            <li>甲方為執行洗錢與資恐防制之目的，乙方及乙方連帶保證人不可撤銷地同意甲方得提供乙方及乙方連帶保證人交易相關資訊(包括但不限於甲方於建立業務往來關係時向乙方取得之交易評估資料、名單檢核資訊或後續履約情形等予甲方之關係企業)且乙方或乙方連帶保證人如有下列情事發生時,乙方及乙方連帶保證人同意甲方毋須事先通知或催告即得婉拒交易或視為乙方發生違約而主張乙方及乙方連帶保證人需立即清償全數債務。1.為資恐防制法指定制裁、外國政府或國際洗錢防制組織認定或追查之恐怖份子或團體者。2. 甲方於審查乙方及乙方連帶保證人身分作業或認為必要時(包括但不限於懷疑涉及非法活動、懷疑洗錢、資助恐怖主義活動等)，得要求乙方於接獲甲方通知後5天內提供審查所需之必要個人、公司、實質受益人或對乙方行使控制權之人等資料、或對交易性質與目的或資金來源進行說明，而不願配合說明或不同意或拒絕提供前開必要之資料者。3. 乙方或乙方連帶保證人拒絕提供甲方定期審視所需相關必要文件或進行合理說明者。若因此發生任何損失、損害或其他不利益，均應由乙方及乙方連帶保證人自行承擔，甲方不負賠償或補償之責。</li>
            <li><u>本契約所載乙方及乙方連帶保證人之約定送達地址為其戶籍地址，如有變更，應以書面通知甲方。如未通知，甲方將有關文書向戶籍地址或最後通知地址發出後，經通常之郵遞期間即視為到達</u>。</li>
          </ul>
          <ul class="list2">
            <span><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li></span>
            <li>本件印花稅各自貼用負擔。本契約書正本壹式貳份，由甲、乙方各持正本一份(乙方應於簽名後將正本一份寄送予甲方)。</li>
            <li>因本契約所生之一切爭議，甲、乙方及乙方連帶保證人同意以台灣士林地方法院為第一審管轄法院，並適用中華民國法律。</li>
          </ul><!--list-->
          <p class="p3">
            乙方及乙方連帶保證人茲確認於於簽訂本契約前已審閱本契約至少一日，並充分瞭解本契約及個別商議條款之全部內容，而簽名如後。<br/>
            此致創鉅有限合夥
          </p><!--p3-->
          <div class="grayBox">
            <div class="sign">
              乙方：
              <img class="box" :src="signImageSrc('signImage1')"/>
              <span class="ps">(正楷簽名)</span><br/>
              <span class="id">身分證字號：<div class="con8">{{editedItem.customer.memberId}}</div></span>
            </div>
            <div class="sign">
               乙方連帶保證人：
               <img class="box" style="top: 60px;" :src="signImageSrc('signImage3')"/>
               <span class="ps">(正楷簽名)</span><br/>
              <span class="id">身分證字號：<div class="con9">{{editedItem.jointGuarantor.memberId}}</div></span>
            </div>
          </div><!--grayBox-->
          <div class="date">
            中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d">105</span>年<span class="d">12</span>月<span class="d">31</span>日
          </div>
          <div class="ft">109&nbsp;年&nbsp;3&nbsp;月版(經銷商/機車)</div>
        </div><!--page2-->
        <div class="page page3">
          <h4>中&nbsp;&nbsp;古&nbsp;&nbsp;機&nbsp;&nbsp;車&nbsp;&nbsp;買&nbsp;&nbsp;賣&nbsp;&nbsp;契&nbsp;&nbsp;約</h4>
          <table class="table1">
            <tr>
              <td width="230px">
                <span class="tdTit">甲方(即出賣人)：</span>
                <div class="con1">{{editedItem.customer.name}}</div>
              </td>
              <td width="200px">
                <span class="tdTit">身分證字號：</span>
                <div class="con2">{{editedItem.customer.memberId}}</div>
              </td>
              <td>
                <span class="tdTit">地址：</span>
                <div class="con3">{{editedItem.customer.home.residenceAddress}}</div>
              </td>
            </tr>
            <tr>
              <td colspan="3">乙方(即買受人)：創鉅有限合夥&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;統一編號：42904351</td>
            </tr>
          </table><!--table1-->
          <p class="p1">
            重大狀況擔保事項：<b>出賣人聲明本案標的無設定動產抵押；且未曾發生重大事故或泡水，惟如不知或有發生則請勾選如下並填寫受損狀況</b><br/>
            （一）<span class="checkbox"><input type="checkbox" disabled></span>曾發生重大事故，受損狀況說明<span class="p1-1">說明說明說明說明說明</span>，<span class="checkbox"><input type="checkbox" disabled></span>不知；（二）<span class="checkbox"><input type="checkbox" disabled></span>為泡水車(<span class="checkbox"><input type="checkbox" disabled></span>全部泡水<span class="checkbox"><input type="checkbox" disabled></span>一半泡水)，<span class="checkbox"><input type="checkbox" disabled></span>不知<br/>
            ⦿所謂『 重大事故』，係指發生事故致機車之引擎或車體主要結構受損或發生其他重大損壞。
          </p>
          <p class="p2">
            價金給付方式：<br/>
            車價：現金交易總價新台幣<span class="p2-1"></span>元整（含稅）
          </p><!--p2-->
          <p class="p3">
            ⦿車價即指買受人應給付之全部價金，出賣人不得再以其他名義，要求買受人給付額外之金額。<br/>
            付款方式：<b>以現金匯付至出賣人指定帳戶（依出賣人提供之本人存摺影本）。預計於買受人確認本契約及相關文件完成之次日撥款</b>。
          </p><!--p3-->
          <p class="p4">
            匯付金額為現金交易總價扣除申請手續費新台幣<span class="p4-1"></span>元及動產擔保設定費用(如有設定)之金額:新台幣<span class="p4-2"></span>元整
          </p><!--p4-->
          <p class="p5">
            交付方式：<b><u>出賣人及買受人約定以民法第七百六十一條規定之占有改定為交付方式，讓買受人取得間接占有。</u></b></br>
            保固責任：<b><u>出賣人及買受人同意依現況交車，出賣人不負瑕疵擔保責任。</u></b></br>
            其他約定事項:
          </p><!--p5-->
          <ul class="list">
            <li><u>出賣人聲明保證本案標的於交車時已完成正常使用檢查且符合交車時之其他相關法令規定，並擔保本件標的物非贓車，且無來歷不明、產權糾紛或其他權利瑕疵之情事，亦非以其他車輛之車牌裝置於本案標的及非由不同車輛解體拼裝之機車。</u></li>
            <li><b><u> 出賣人並保證本案標的之所有權確係出賣人本人所有，並且絕無提供予任何第三者設定動產抵押權、附條件買賣、信託占有或其他設定負擔處分之行為或遭第三人主張有權占有(如:當鋪)，或涉及其他債務關係，亦無政府法令禁止扣押或禁止持有、轉讓或質押之物品，如有任何糾紛概由出賣人自行負責處理，與買受人無關，如聲明不實，買受人得對出賣人主張應負之民、刑事責任。</u></b></li>
            <li>出賣人同意於本買賣契約成立後若再向買受人買回本案標的時，如有瑕疵或設計、製造不良而致減少通常效用或故障時，願自費負責修繕絕無異議。</li>
            <li>標的物之利益及危險，自交付時起，因出賣人仍占有使用車輛，故由出賣人承受及負擔。</li>
            <li>交車前欠繳之一切稅費及罰鍰，均由出賣人負擔。<b><u>出賣人並同意支付新台幣伍仟元作為本案申請手續費，且授權買受人得自給付予出賣人之買賣款項中扣除，後續如因故解除或終止本案相關契約亦不予退還。</u></b></li>
            <li>買受人要求試車時，因試車所生之任何損害，除可歸責於買受人之事由所致者外，均由出賣人負擔。</li>
            <li>出賣人已充分知悉且了解本契約之各條約款並同意受拘束，並親自簽署本契約及相關之債權文件，並同意於買受人收訖前述文件並支付價金前，本契約對買受人並無拘束力，買受人仍保有本契約最終往來決定權；買受人支付本契約之買賣價金後，則視為買受人已同意本契約之各條約款並同意受拘束<b><u>，如買受人拒絕支付價金，出賣人同意買受人無須返還出賣人簽署之文件原本及所提供之相關資料</u></b>。本契約訂立後，若有任何增刪修改，須經雙方當事人書面同意。</li>
            <li>本件印花稅各自貼用負擔。本契約書正本壹式貳份，由買受人及出賣人各持正本一份(甲方應於簽名後將正本一份寄送予乙方)。</li>
          </ul>
          <p class="p6">
            甲方茲確認於簽訂本契約前已審閱本契約至少一日並充分瞭解本契約全部條款之內容，而簽名如後。<br/>
            此致創鉅有限合夥
          </p>
          <div class="grayBox">
            甲方：(正楷簽名)<br>
            <span class="id">身分證字號：<div class="con4">{{editedItem.customer.memberId}}</div></span>
          </div>
          <div class="date">
            中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d">105</span>年<span class="d">12</span>月<span class="d">31</span>日
          </div>
          <div class="line"></div>
          <div class="btBox">
            <h6>本票</h6>
            <p>
              憑票於中華民國年月日無條件承擔支付創鉅有限合夥或其指定人<br/>
              新台幣<span class="btBox-1">{{editedItem.vendor.totalCreditPrice}}</span>元整。此票免除作成拒絕證書及票據法第八十九條之通知義務，利息自到期日起按年息百分之二十計付。本票據之發票人不可撤銷地授權持票人及其代理人或其指定之人填載本票據之到期日及其他應記載事項。<br/>
              付款地:台北市內湖區內湖路一段&nbsp;392&nbsp;號&nbsp;6&nbsp;樓<br/>
              此據
            </p>
            <div class="grayBox2">發票人：<span class="ps">(正楷簽名)</span></div>
            <div class="date2">
              中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;華&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;國<span class="d">105</span>年<span class="d">12</span>月<span class="d">31</span>日
            </div>
          </div><!--btBox-->
          <div class="ft">109&nbsp;年&nbsp;3&nbsp;月版(經銷商/機車)</div>
        </div><!--page3-->
      </div><!--wrapper-->
</template>

<script>
export default {
  name: "EntrepreneurPrint",
  props: {
    item: Object
  },
  data() {
    return {
    }
  },
  computed: {
    editedItem() {
      return this.item;
    },
  },
  methods: {
    signImageSrc(itemPath){
      let source = null;
      if (itemPath === 'signImage1'){
        if (this.editedItem.signImage1) {
          source = this.editedItem.signImage1;
        } else if(this.editedItem.signimage1Url) {
          source = this.editedItem.signimage1Url;
        }
      } else if(itemPath === 'signImage2'){
        if (this.editedItem.signImage2){
          source = this.editedItem.signImage2;
        } else if(this.editedItem.signimage2Url) {
          source = this.editedItem.signimage2Url;
        }
      } else if(itemPath === 'signImage3'){
        if (this.editedItem.signImage3){
          source = this.editedItem.signImage3;
        } else if(this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
  }
}
</script>

<style scoped src="../../assets/css/entrepreneur_print.css">
</style>

<style scoped>
.box {
  position: absolute;
  width: 150px;
  height: 38px;
  left: 160px;
  top: 2px;
  background: #ffffff;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/web/EntrepreneurPrint.vue